import React from 'react'

const Manual_canjear_beneficios_clau_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Canjear beneficios de Clau.io en Invu POS
        </h2>
        <iframe
          src="https://scribehow.com/embed/Canjear_beneficios_de_Clau_io_en_Invu_POS__J1ngD6R4SsupsXHm2nd2Mg?as=scrollable"
          className="scribe-iframe-general-71"
          width="100%"
          height="7000"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_canjear_beneficios_clau_invu
